export default __webpack_public_path__ + "static/media/WinFromHome_159x150.dd26d6aa.png";